import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET, POST, PUT } from "../utils/Methods";

export const GetAllTest = createAsyncThunk(
  "test/exam/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Test.AllTest}?name=${filter?.name || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const startTest = createAsyncThunk(
  "test/exam/start-test",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Test.startTest}/${id}`);
      const payload = res?.data?.success !== undefined ? res.data : res;

      if (payload.success) {
        return payload;
      } else {
        return rejectWithValue(payload);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "contain",
  initialState: {
    data: [],
    single: null,
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTest.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllTest.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllTest.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(startTest.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(startTest.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (count) => count.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(startTest.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
